import { BindOptions } from '../interfaces';
import { DeliveryMode, SourceType, PlayType } from '../../common/constants';
import InterceptorStack from '../../interceptor/InterceptorStack';
import autobind from '../../autobind';

export type BoolFunction = () => boolean;
export type BindOptionsFunction = () => BindOptions;

export const defaultGetOptions = (): BindOptions => {
  return {
    activeMode: DeliveryMode.NONE,
    playType: PlayType.UNKNOWN,
    sourceType: SourceType.SMOOTH,
    stack: (undefined as unknown) as InterceptorStack
  };
};

export class InterceptBinder {
  _shouldIntercept: BoolFunction;
  _getOptions: BindOptionsFunction;

  constructor() {
    autobind(this);
    this._shouldIntercept = () => false;
    this._getOptions = defaultGetOptions;
  }

  getOptions(): BindOptions {
    return this._getOptions();
  }

  shouldIntercept(): boolean {
    return this._shouldIntercept();
  }

  reset(): void {
    this._shouldIntercept = () => false;
    this._getOptions = defaultGetOptions;
  }

  updateBinder(
    shouldIntercept: BoolFunction,
    getOptions: BindOptionsFunction
  ): void {
    if (typeof shouldIntercept === 'function') {
      this._shouldIntercept = shouldIntercept;
    }
    if (typeof getOptions === 'function') {
      this._getOptions = getOptions;
    }
  }
}
